export function preferencesAgentJson (language) {
  let items

  if (language === 'es') {
    items = {
      downloadAndroidAgent: {
        name: 'downloadAndroidAgent',
        label: 'descargar el agente de Android del MDM'
      },
      downloadWindowsAgent: {
        name: 'downloadWindowsAgent',
        label: 'descargar el agente de Windows del MDM'
      }
    }
  } else if (language === 'en') {
    items = {
      downloadAndroidAgent: {
        name: 'downloadAndroidAgent',
        label: 'download the Android MDM Agent'
      },
      downloadWindowsAgent: {
        name: 'downloadWindowsAgent',
        label: 'download the Windows MDM Agent'
      }
    }
  }
  return (items)
}
